/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { bind } from "lodash";
import { View } from "backbone.marionette";
import template from "templates/modal/modal_layout.hbs";

export default class ModalLayout extends View.extend({
  template,

  attributes: {
    style: "display: none;"
  },

  triggers: {
    'click [data-behavior="modal-close"]': "click:modal:close"
  },

  regions: {
    content: '[data-region="content"]'
  }
}) {
  onClickModalClose() {
    return this.closeModal();
  }

  initialize(options) {
    this.vent = options.vent;
    this.dialog = this.$el[0];

    this.listenTo(this.vent, "modal:open", view => {
      this.view = view;
      this.updateContent(view);
      return this.open();
    });

    return this.listenTo(this.vent, "modal:close", () => {
      return this.closeModal();
    });
  }

  updateContent(view) {
    return this.showChildView("content", view);
  }

  closeModal() {
    this.vent.trigger("modal:before:close");
    this.dialog.close();
    this.dialog.setAttribute("inert", "");
    setTimeout(() => {
      this.getRegion("content").reset();
    }, 550);
    return this.vent.trigger("modal:after:close");
  }

  open() {
    this.vent.trigger("modal:before:show");
    Radio.channel("globalChannel").trigger("user:action");
    this.dialog.showModal();
    this.dialog.removeAttribute("inert");
    this.vent.trigger("modal:after:show");
    return this.view.trigger("modal:after:show");
  }
}
